import { ColumnDef } from '@tanstack/react-table'
import { ClinicGroup } from '@magnetar/admin-api-interfaces'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { useViewModeActions } from '@/hooks/useViewModeActions'
import { LogIn } from 'lucide-react'

export const columns: ColumnDef<ClinicGroup>[] = [
  {
    accessorKey: 'clinic_group_id',
    header: 'ID',
    cell: ({ row }) => {
      const id: number = row.getValue('clinic_group_id')
      return (
        <Badge variant="outline" className="font-medium">
          {id}
        </Badge>
      )
    },
  },
  {
    accessorKey: 'group_code',
    header: '代碼',
    cell: ({ row }) => {
      const code: string | null = row.getValue('group_code')
      return code || '-'
    },
  },
  {
    accessorKey: 'group_name',
    header: '集團名稱',
  },
  {
    accessorKey: 'manager_name',
    header: '負責人',
  },
  {
    accessorKey: 'phone',
    header: '電話',
  },
  {
    accessorKey: 'is_active',
    header: '狀態',
    cell: ({ row }) => {
      const is_active: boolean = row.getValue('is_active')
      return (
        <Badge variant={is_active ? 'default' : 'secondary'}>{is_active ? '啟用' : '停用'}</Badge>
      )
    },
  },
  {
    id: 'actions',
    cell: function ActionsCell({ row }) {
      const clinicGroup = row.original
      const { setClinicGroupMode } = useViewModeActions()

      const handleEnterGroup = () => {
        setClinicGroupMode(clinicGroup.clinic_group_id)
      }

      return (
        <Button variant="outline" size="sm" onClick={handleEnterGroup}>
          <LogIn className="mr-1 h-3 w-3" />
          進入集團
        </Button>
      )
    },
  },
]
